import React, { createContext, ReactNode, useEffect, useState } from "react";
import axios from "axios";

type AuthStatus = "loading" | "authenticated" | "unauthorized";

interface AuthContextType {
  authStatus: AuthStatus;
  setAuthStatus: React.Dispatch<React.SetStateAction<AuthStatus>>;
}

export const AuthContext = createContext<AuthContextType>({
  authStatus: "loading",
  setAuthStatus: () => {},
});

interface AuthProviderProps {
  children: ReactNode;
}

const API_URL = process.env.REACT_APP_API_URL;

export function AuthProvider({ children }: AuthProviderProps) {
  const [authStatus, setAuthStatus] = useState<AuthStatus>("loading");

  const checkAuth = async () => {
    try {
      await axios.get(`${API_URL}/auth/instructors/check`, {
        withCredentials: true,
      });
      setAuthStatus("authenticated");
    } catch {
      setAuthStatus("unauthorized");
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ authStatus, setAuthStatus }}>
      {children}
    </AuthContext.Provider>
  );
}
